import {makeActionCreator} from '../../redux-toolbelt';

import {CurrentDeliveryMethodState} from './currentDeliveryMethodReducer';

export const setCurrentDeliveryMethod =
  makeActionCreator<'setCurrentDeliveryMethod', CurrentDeliveryMethodState>('setCurrentDeliveryMethod');
